// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.weak-set.of.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.weak-set.of.js
// module chunks = 4